<template>
  <ons-page id="invitation">
    <div class="channel-header ">
      <section>
        <div class="avatar-line justify-row container">
          <div class="avatar avatar-podcast">
            <div class="avatar-border"></div>
            <img-with-placeholder class="round-sm" :src="constants.phImg70x70" :data-src="sizeImg(invitation.channel.image.base_url, 70, 70)" :alt="invitation.channel.image.alt_text" v-if="invitation" />
            <img class="round-sm" :src="constants.phImg70x70" v-else>
          </div>
          <div class="main-item">
            <h2 class="name"
                v-if="invitation"
            >{{ invitation.channel.title }}</h2>
          </div>
        </div>
        <div class="container">
          <p class="p" v-if="invitation">{{ invitation.channel.short_description | truncate(400) }}</p>
          <div class="form-row justify-row small">
            <div class="main-item">
              <v-ons-button class="reset-submit js-newpage" @click="acceptInvitation()">{{ $t("ui.accept") }}</v-ons-button>
              <a class="link-register button--quiet button--small js-newpage" @click.prevent="navigatorResetMain({})" modifier="quiet small" href="">{{ $t("ui.cancel") }}</a>
            </div>
            <div>
            </div>
          </div>
        </div>        

      </section>
    </div>
  </ons-page>
</template>

<script>
import CurrentUser from '@/models/CurrentUser';
import Channel from '@/models/Channel';
import axios from 'axios';
import PopupHelper from '@/mixins/PopupHelper';

export default {
  name: 'invitation',
  mixins: [PopupHelper],
  props: ['invitationToken'],

  data() {
    return {
      invitation: null,
      errors: {},
    };
  },

  methods: {
    acceptInvitation() {
      axios
      .post(`/api/invitations/${this.invitationToken}/accept`, { user_id: this.currentUser.id })
      .then(res => {
        this.navigateToChannel();
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.navigatorResetLogin(this.$t("messages.login_required"));
        } else if (error.response && error.response.status === 410) {
          this.$ons.notification.toast(this.$t("messages.expired_invitation"), { timeout: 3000, animation: 'fall' });
        } else if (error.response && error.response.status === 422 && error.response.data && error.response.data.errors && error.response.data.errors.channel_id && error.response.data.errors.channel_id.length === 1 && error.response.data.errors.channel_id[0] === 'has already been taken') { // already accepted
          this.$ons.notification.toast(this.$t("messages.invitation_already_accepted"), { timeout: 3000, animation: 'fall' });
          this.navigateToChannel();
        } else {
          console.log(error);
          this.showSomethingWrongToast();
        }
      });
    },

    navigateToChannel() {
      this.navigatorReplace('Channel', { id: this.invitation.channel.id, title: this.invitation.channel.title });
    },
  },

  created() {
    if (!this.invitationToken) {
      this.navigatorResetMain({}, this.$t("messages.invalid_invitation"));
      return;
    }

    axios.get(`/api/invitations/${this.invitationToken}`).then((res) => {
      this.invitation = res.data;

      // require login popup
      if (!this.currentUser || this.currentUser._is_guest) {
        this.$ons.notification.toast(this.$t("messages.login_required_to_accept_invitation"), { timeout: 7000, animation: 'fall' });
        this.navigatorPushLogin({allowPop: true});
      }

      // check if already accepted
      Channel.fetchById(this.invitation.channel.id).then((res) => {
        if (res.response.data.is_subscribed) {
          this.$ons.notification.toast(this.$t("messages.invitation_already_accepted"), { timeout: 3000, animation: 'fall' });
          this.navigateToChannel();
        }
      }).catch((err) => {});
    }).catch((error) => {
      if (error.response && error.response.status === 404) {
        this.navigatorResetMain({}, this.$t("messages.invalid_invitation"));
      } else if (error.response && error.response.status === 410) {
        this.navigatorResetMain({}, this.$t("messages.expired_invitation"));
      } else {
        console.log(error);
        this.navigatorResetMain({}, this.$t("messages.something_wrong"));
      }
    });
  },
};
</script>
